class InputCounter {
    constructor(inputCounterWrapper) {
        this.inputCounterWrapperE = inputCounterWrapper;
        this.inputCounterE = this.inputCounterWrapperE.querySelector('.k-input-counter');
        this.characterCounterE;
        this.maxLength = this.inputCounterE.getAttribute('maxlength');


        if (this.inputCounterE && this.maxLength) {
            this._initCounter();
        } else {
            console.log('All parameters are required.');
        }
    }

    _initCounter() {
        console.log(this.inputCounter)

        if (this.inputCounterE.value.length > this.maxLength) {
            this.inputCounterE.value = this.inputCounterE.value.substr(0, this.maxLength);
        }

        let counterHTML = `
            <p class="k-character-counter k-notifications">
                ${this.inputCounterE.value.length}/${this.maxLength}
            </p>
        `;

        this.inputCounterWrapperE.insertAdjacentHTML('beforeend', counterHTML);
        this.characterCounterE = this.inputCounterWrapperE.querySelector('.k-character-counter');

        this.inputCounterE.addEventListener('input', (e) => {
            let counter = this.inputCounterE.value.length;
            if (counter > this.maxLength) {
                counter = this.maxLength;
                this.inputCounterE.value = this.inputCounterE.value.substr(0, this.maxLength);
            }
            if (counter < 0) {
                counter = 0;
            }
            this.characterCounterE.innerText = `${counter}/${this.maxLength}`;
        })
    }
 
}

let inputCounterInstances = [];

const init = (inputCounterWrapper) => {
    if (inputCounterWrapper) {
        if (typeof inputCounterWrapper.length == 'undefined') {
            const htmlElement = inputCounterWrapper;
            inputCounterInstances = new InputCounter(htmlElement);
        } else {
            for (let i = 0; i < inputCounterWrapper.length; i++) {
                const htmlElement = inputCounterWrapper[i];
                let newInputCounterInstance = new InputCounter(htmlElement);
                inputCounterInstances.push(newInputCounterInstance);
            }
        }
    }

    return inputCounterInstances;
}


export {
    init
};